import Button from '@mui/material/Button'
import Tooltip from '@mui/material/Tooltip'
import useNavigation from '../Utils/navigationUtils'

const QrButtonIconPath = `${process.env.REACT_APP_ANEARAPP_ASSETS_URL}qr_code_icon_scan_button_2.png`

const ScanQrButton = _ => {
  const { navigateToScanPage } = useNavigation()

  const handleClick = _e => {
    navigateToScanPage()
  }

  return (
    <Tooltip title="Scan QR Code to Join Event" arrow placement="top">
      <Button
        sx={{
          p: 0.9,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          minWidth: 'auto',
          bgcolor: 'rgba(15,23,42,0.9)',
          borderRadius: '999px',
          border: '0.14rem solid rgba(96,165,250,0.9)',
          boxShadow: '0 10px 25px rgba(15,23,42,0.8)',
          transition: 'transform 120ms ease-out, box-shadow 120ms ease-out, border-color 120ms ease-out, background-color 120ms ease-out',
          '&:hover': {
            borderColor: 'rgba(129, 212, 250, 1)',
            bgcolor: 'rgba(15,23,42,1)',
            boxShadow: '0 14px 32px rgba(15,23,42,0.95)',
            transform: 'translateY(-1px)'
          },
          '&:active': {
            transform: 'translateY(1px) scale(0.97)',
            boxShadow: '0 6px 18px rgba(15,23,42,0.8)'
          }
        }}
        onClick={e => handleClick(e)}
        aria-label="Scan QR Code to Join Event"
      >
        <img
          style={{ height: '2.5rem', width: 'auto', display: 'block' }}
          src={QrButtonIconPath}
          alt="QR Code Scanner"
        />
      </Button>
    </Tooltip>
  )
}

export default ScanQrButton
